import { NavLink } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useEffect, useState, useCallback } from "react";
import axios from "axios";
import config from "../../configuration/config";
import { User_Data_Key, getData } from "../../utils/localStorageManager";
import LogoutButtonV7 from "../../components/logout/LogoutButtonV7";
import "../UserV7.scss";

function Navlink({ title, to, icon, state, handelonClick, ...props }) {
  return (
    <NavLink {...props} to={to} className={"user-nav-link-v7 " + (state || "")}
      onClick={() => {
        if (handelonClick)
          handelonClick();
      }}>
      <div className="nav-link-content-v7">
        <img src={"/assets/user_profile/icons/" + icon} alt={title} className="nav-icon-v7" />
        <div className="link-text">{title}</div>
      </div>
    </NavLink>
  );
}


export default function UserNav({ url }) {
  const defaultProfileImage = '/assets/images/profile.jpg';
  const { t: trans, i18n } = useTranslation(["common", "model", "info", "user", "home", "navbar"]);
  const lang = (i18n.language || 'ar');
  const pageDir = 'language-' + lang;

  const [showBottomSheet, setShowBottomSheet] = useState(false);
  const [userInfo, setUserInfo] = useState({});
  const [names, setNames] = useState('');
  const [imageProfile, setImageProfile] = useState(defaultProfileImage);

  const b64toBlob = (b64Data, contentType = '', sliceSize = 512) => {
    const byteCharacters = atob(b64Data);
    const byteArrays = [];

    for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
      const slice = byteCharacters.slice(offset, offset + sliceSize);
      const byteNumbers = new Array(slice.length);
      for (let i = 0; i < slice.length; i++) {
        byteNumbers[i] = slice.charCodeAt(i);
      }
      const byteArray = new Uint8Array(byteNumbers);
      byteArrays.push(byteArray);
    }
    const blob = new Blob(byteArrays);
    return blob;
  };

  const intialUserData = useCallback(async () => {
    try {
      const userKey = getData('secretKey');
      if (!userKey) return;
      const settingsResponse = await axios.request({
        baseURL: config.controllURL,
        url: (i18n.language || 'ar') + "/api/user/GetUserImage",
        method: "get",
        params: { ID: userKey },
      });

      if (settingsResponse.status === 200) {
        const imgeUser = settingsResponse?.data?.userImage?.Logo;
        if (imgeUser) {
          setImageProfile(URL.createObjectURL(b64toBlob(imgeUser)));
        } else {
          setImageProfile(defaultProfileImage);
        }
      }
    } catch (err) {
      console.log(err);
    }
  }, [i18n.language]);

  useEffect(() => {
    const langCode = i18n.language || 'ar';
    const langKey = langCode === 'ar' ? 'Ar' : 'En';
    try {
      const data = getData(User_Data_Key, true);
      if (data) {
        const _temp = JSON.parse(data);
        setUserInfo(_temp);
        const firstName = _temp[`FirstName${langKey}`] || _temp[`${langCode}FirstName`];
        const lastName = _temp[`LastName${langKey}`] || _temp[`${langCode}LastName`];
        let finalResult = trans("info:no_set_names");
        if (firstName)
          finalResult = firstName + ' ' + (lastName || '');
        setNames(finalResult);
      }
    } catch (error) {
      console.log(error);
    }
    intialUserData();
  }, [i18n.language, trans, intialUserData]);

  const NavItems = (isMobile = false) => (
    <>
      <Navlink exact to={`${url}`} title={trans("common:home")} icon={"home.svg"} handelonClick={() => setShowBottomSheet(false)} />
      <Navlink to={`${url}/profile`} title={trans("user:profile")} icon={"user.svg"} handelonClick={() => setShowBottomSheet(false)} />
      <Navlink to={`${url}/notifications`} title={trans("user:notifications")} icon={"notification.svg"} handelonClick={() => setShowBottomSheet(false)} />
      <Navlink to={`${url}/vehicles`} title={trans("common:vehicle")} icon={"car.svg"} handelonClick={() => setShowBottomSheet(false)} />
      {isMobile && <Navlink to="/periodic-maintenance" title={trans("navbar:periodic_maintenance")} icon={"maintenance.svg"} handelonClick={() => setShowBottomSheet(false)} />}
      <Navlink to={`${url}/favorite`} title={trans("user:favorite")} icon={"favorite.svg"} handelonClick={() => setShowBottomSheet(false)} />
      <Navlink to={`${url}/offers`} title={trans("home:offers")} icon={"offer.svg"} handelonClick={() => setShowBottomSheet(false)} />
      <Navlink to={`${url}/myOrders`} title={trans("user:myOrders")} icon={"history.svg"} handelonClick={() => setShowBottomSheet(false)} />
      <Navlink to={`${url}/myBookings`} title={trans("info:my-bookings")} icon={"offer.svg"} handelonClick={() => setShowBottomSheet(false)} />
    </>
  );

  return (
    <>
      {/* Desktop Sidebar */}
      <div className={`user-sidebar-v7 ${pageDir} hidden lg:block`}>
        <div className="user-sidebar-header-v7">
          <img src={imageProfile} alt="Profile" className="user-avatar-v7" />
          <h3 className="user-name-v7 ellipsis">{names}</h3>
        </div>
        <div className="user-nav-v7">
          {NavItems(false)}
        </div>

        <div className="user-sidebar-footer-v7">
          <LogoutButtonV7 className="v7-logout-btn" />
        </div>
      </div>

      {/* Mobile Sticky Trigger */}
      <button
        className="mobile-profile-trigger flex lg:hidden"
        onClick={() => setShowBottomSheet(true)}
      >
        <img src="/assets/user_profile/icons/user.svg" width={25} height={25} alt="" className="w-11 h-11 brightness-0 invert" />
        <span className="text-white text-3xl">{trans("user:profile")}</span>
      </button>

      {/* Mobile Bottom Sheet */}
      <div
        className={`profile-bottom-sheet-overlay ${showBottomSheet ? 'active' : ''}`}
        onClick={() => setShowBottomSheet(false)}
      ></div>
      <div className={`profile-bottom-sheet ${showBottomSheet ? 'active' : ''} ${pageDir}`}>
        <button className="sheet-close-v7" onClick={() => setShowBottomSheet(false)} aria-label="Close">
          <svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round">
            <line x1="18" y1="6" x2="6" y2="18"></line>
            <line x1="6" y1="6" x2="18" y2="18"></line>
          </svg>
        </button>
        <div className="sheet-header-v7">
          <div className="sheet-handle"></div>
          <h3>{trans("user:profile")}</h3>
        </div>
        <div className="sheet-profile-info-v7">
          <div className="profile-image-container-v7">
            <img src={imageProfile} alt="Profile" />
          </div>
          <div className="profile-details-v7">
            <h4>{names}</h4>
            <p>{userInfo?.email || userInfo?.phone}</p>
          </div>
        </div>
        <div className="sheet-nav-v7">
          {NavItems(true)}
        </div>
        <div className="sheet-footer-v7">
          <LogoutButtonV7 className="v7-logout-btn-mobile" />
        </div>
      </div>
    </>
  );
}

